<div class="modal-body content width-600">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{isNew ? getRessource('CreateHeader') : getRessource('EditHeader')}}
    </span>
		<div class="modal-form content height-400">
			<exg-input [(ngModel)]="dataModelClone.frmVName"
			           [caption]="enumSvc.getFieldCaption('FormularVersion', 'frmVName')"
			           [required]="isNew || (dataModelClone.frmVName && dataModelClone.frmVName.length === 0)">
			</exg-input>
			<exg-textarea [(ngModel)]="dataModelClone.frmVDescription"
			              [caption]="enumSvc.getFieldCaption('FormularVersion', 'frmVDescription')">
			</exg-textarea>
			<!--Status-->
			<app-exg-select-enumeration [value]="dataModelClone.frmV_enmIdent_FormularVersionStatus"
			                            listDisplay="enmText"
			                            (valueChange)="changeStateEnum($event)"
			                            [caption]="enumSvc.getFieldCaption('FormularVersion', 'frmV_enmIdent_FormularVersionStatus')"
			                            enumerationName="FormularVersionStatus"
			                            class="span-6">
			</app-exg-select-enumeration>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModelClone?.cvID && !data.hideDelete">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="isDisabled"
			        class="md-btn">
				{{isNew ? getGlobal('Create') : getGlobal('Save')}}
			</button>
		</div>
	</div>
</div>
